let current = 0;

export function sequence() {
	return current++;
}
